import type { HelpFile } from '../../types/help'
import { AssignRoleDialogTestIds } from '../../../testids/AssignRoleDialogTestIds'

export const assignRoleDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [AssignRoleDialogTestIds.assignRoleCombobox]:
      'Search and select a role to assign to this service account. Roles already assigned are not listed.',
    [AssignRoleDialogTestIds.assignRoleDialogTitle]: 'Assign Role',
    [AssignRoleDialogTestIds.assignRoleForm]:
      'Select a role and submit to grant it to the service account.',
    [AssignRoleDialogTestIds.assignRoleInlineError]:
      'Shown when the role is already assigned (409). Pick a different role.',
  },
}
